<template>
  <div class="apply-container">
    <top-nav :shrinked="true"/>
    <div class="banner">
      <img src="@/assets/6.jpg">
    </div>
    <div class="apply-content">
        <div class="test-drive-form">
            <form class="">
                <div class="n-dynamic-form-field n-dynamic-form-select-field" :class="{'n-dynamic-form-field-active':projectActive,'error':error.project}" @click="projectClick">
<!--                    <label :class="{'n-dynamic-default-label':!form.projectId}">-->
<!--                        {{project}}-->
<!--                        <span v-if="''==form.projectId" class="required">*</span>-->
<!--                    </label>-->
                    <div class="select-no-content">
                        <el-select class="select-no-border" v-model="form.projectIds" multiple collapse-tags placeholder="意向项目" style="width: 100%;">
                            <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                        <span v-if="form.projectIds.length==0" class="required select-required">*</span>
                    </div>
                    <div v-if="error.project" class="n-dynamic-form-error">请输选择意向项目</div>
<!--                    <ul id="divBtn" class="n-dynamic-form-select-field-options" :style="projectActive?'display:block;':'display:none;'">-->
<!--                        <li-->
<!--                                v-for="(item,index) in options"-->
<!--                                :key="index"-->
<!--                                :class="{'n-dynamic-form-select-field-option-active':(form.projectId && form.projectId==item.value)}"-->
<!--                                @click.stop="liClick(item,index)">-->
<!--                            {{item.label}}-->
<!--                        </li>-->
<!--                    </ul>-->
                </div>
                <div class="n-dynamic-form-cnsms-field">
                    <div class="n-dynamic-form-cnsms-field-phone-wrapper">
                        <div class="n-dynamic-form-field n-dynamic-form-text-field" :class="{'error':error.name}">
                            <input maxlength="11" type="text" placeholder="姓名" v-model="form.name">
                            <span v-if="''==form.name" class="required">*</span>
                            <div v-if="error.name" class="n-dynamic-form-error">请输入姓名</div>
                        </div>
                    </div>
                    <div class="n-dynamic-form-cnsms-field-phone-wrapper">
                        <div class="n-dynamic-form-field n-dynamic-form-text-field" :class="{'error':error.phone}">
                            <input maxlength="11" type="text" placeholder="手机号" v-model="form.phone">
                            <span v-if="''==form.phone" class="required" style="left: 55px;">*</span>
                            <div v-if="error.phone" class="n-dynamic-form-error">请输入正确的手机号</div>
                        </div>
                    </div>
                    <div class="n-dynamic-form-cnsms-field-sms-wrapper">
                        <div class="n-dynamic-form-field n-dynamic-form-text-field">
                            <input maxlength="100" type="text" placeholder="需求备注" v-model="form.remark">
                        </div>
                    </div>
                </div>
                <div class="n-dynamic-form-button-wrapper" @click="submit">
                    <div class="n-dynamic-form-submit-button" :class="{'disabled':btnDisabled}">预约看房</div>
                </div>
            </form>
            <p class="n-dynamic-form-disclaimer">*购房权益及详情请咨询置业顾问。</p>
        </div>
    </div>
  </div>
</template>


<script>
import topNav from '@/components/base/top-nav'
import {fetchDict} from '@/api/join.js'
import {apply} from '@/api/apply.js'
import $ from 'jquery';
export default {
  name: "apply",
    components:{
        topNav
    },
  data() {
    return {
      form:{
          projectId:'',
          projectIds:[],
          name:'',
          phone:'',
          remark:'',
      },
      error:{
          project:false,
          name:false,
          phone:false,
      },
      project:'意向项目',
      options1: [
        {
        value: '1',
        label: '常州-国色风华'
      }, {
        value: '2',
        label: '常州-风华瓴著'
      }, {
        value: '3',
        label: '常州-山和风华'
      }, {
        value: '4',
        label: '常州-一江风华'
      }, {
        value: '5',
        label: '常州-澎湃'
      }, {
        value: '6',
        label: '常州一星光城'
      }, {
        value: '7',
        label: '常州一九里晴川'
      }, {
        value: '8',
        label: '常州-湖光印月'
      }, {
        value: '9',
        label: '无锡-悦印风华'
      }, {
        value: '10',
        label: '泰州--上河风华'
      }],
      options: [
        {
        value: '1',
        label: '南京——万流江宁'
      }, {
        value: '2',
        label: '泰州——上河风华'
      }, {
        value: '3',
        label: '常州——国色风华'
      }, {
        value: '4',
        label: '常州——山和风华'
      }, {
        value: '5',
        label: '常州——空港星光城'
      }, {
        value: '6',
        label: '常州——一江风华'
      }, {
        value: '7',
        label: '常州——风华瓴著'
      }, {
        value: '8',
        label: '常州——万流一源'
      }],
      projectActive:false,
      btnDisabled:false,
      isSubmit:false
    }
  },
    watch: {
        'form.projectIds': {
            handler (nVal, oVal) {
                if(this.isSubmit){
                    this.variableProject()
                }
            }
        },
        'form.name': {
            handler (nVal, oVal) {
                if(this.isSubmit){
                    this.variableName()
                }
            }
        },
        'form.phone': {
            handler (nVal, oVal) {
                console.log(nVal, oVal)
                if(this.isSubmit){
                    console.log('nVal, oVal)')
                    this.variablePhone()
                }
            }
        }
    },
  mounted() {
      //点击非当前下拉菜单区域时，关闭下拉菜单
      // $(document).mousedown(function(e){
      //     var _con = $('.n-dynamic-form-select-field-options');
      //     //1. 点击事件的对象不是目标元素本身
      //     //2. 事件对象同时也不是目标元素的子元素
      //     if(!_con.is(e.target) && _con.has(e.target).length===0){
      //         this.projectActive = false;
      //         console.log('1111')
      //     }
      // });
  },
  methods: {
      /**
       * 项目列表
       */
      getDictList(){
          let project_list = 'project_list'
          fetchDict(project_list).then(res=>{
              this.options = res.data
          })
      },
      initError(){
          this.error = {
              project:false,
              name:false,
              phone:false,
          }
      },
      projectClick(){
          this.projectActive = !this.projectActive;
      },
      liClick(item,index){
          this.projectActive = false;
          this.form.projectId = item.value
          this.project = item.label
      },
      variableProject(){
          this.error.project = false
          if(this.form.projectIds.length == 0){
              this.error.project = true
              return
          }
      },
      variableName(){
          this.error.name = false
          if('' == this.form.name){
              this.error.name = true
              return
          }
      },
      variablePhone(){
          this.error.phone = false
          if('' == this.form.phone || this.form.phone.length!=11){
              this.error.phone = true
              return
          }
      },
      submit(){
          this.initError()
          this.isSubmit = true
          if(this.form.projectIds.length == 0){
              this.error.project = true
          }
          if('' == this.form.name){
              this.error.name = true
          }
          if('' == this.form.phone || this.form.phone.length!=11){
              this.error.phone = true
          }
          if(!this.error.project && !this.error.name && !this.error.phone){
              this.btnDisabled = true
              let projects = ''
              this.form.projectIds.forEach(item=>{
                  projects += item +','
              })
              this.form.projectId = projects.substring(0,projects.length-1)
              apply(this.form).then(res=>{
                  this.$message({
                      message: '预约成功',
                      type: 'success'
                  });
                  this.btnDisabled = false
              }).catch(err=>{
                  this.btnDisabled = false
              })
          }
      }
  }
}
</script>

<style>
  @import "../../styles/apply.css";
</style>
<style lang="scss" scoped>
    .n-dynamic-form-field{
        ::v-deep .select-no-border .el-input__inner {
            border-color: transparent!important;
            background: transparent;
            padding: 0;
            height: 32px;
            line-height: 32px;
        }
        ::v-deep .select-no-border ::placeholder {
            color: #939799;
        }
        .select-no-content{
            position:relative;
        }
        .select-required{
            position: absolute;
            left: 61px;
            top: 0;
            z-index: 10;
        }
        ::v-deep .select-no-border ::placeholder::after {
            position: absolute;
            top: 0;
            right: 0;
            z-index: 50;
            content: ' *';
            color: red;
        }
        ::v-deep .select-no-border .el-select__tags{
            left: -6px;
        }
        ::v-deep .select-no-border .el-input .el-input__icon{
            width: 32px;
            height: 32px;
            line-height: 32px;
        }
        ::v-deep .select-no-border .el-input .el-select__caret {
            transform: rotateZ(90deg);
            -webkit-transform: rotateZ(90deg);
            color: #000;
        }
        ::v-deep .select-no-border .el-input .el-select__caret.is-reverse{
            transform: rotateZ(180deg);
            -webkit-transform: rotateZ(180deg);
        }
    }




</style>
